import React, { useState } from 'react';
import { Projet, SituationTravaux, StatutTS, Incident, SituationSousTraitant } from '../types';
import { useProjetCalculations } from '../hooks/useProjetCalculations';
import SuiviChantierHeader from './SuiviChantierHeader';
import MATOverview from './MATOverview';
import LotTable from './LotTable';
import IncidentsSection from './IncidentsSection';
import SituationModal from './SituationModal';
import GanttChart from './GanttChart';

interface SuiviChantierProps {
  projet: Projet;
  onRetour: () => void;
  onAjouterSituation: (projetId: string, lotId: string, situation: Omit<SituationTravaux, 'id'>) => void;
  onAjouterTS: (projetId: string, lotId: string, ts: {
    intitule: string;
    montant: number;
    commentaire?: string;
    dateAjout: string;
    statut: StatutTS;
  }) => void;
  onAjouterIncident?: (projetId: string, incident: Omit<Incident, 'id' | 'projetId'>) => void;
  onResoudreIncident?: (projetId: string, incidentId: string) => void;
  onAjouterSituationST?: (projetId: string, lotId: string, situation: Omit<SituationSousTraitant, 'id'>) => void;
}

const SuiviChantier: React.FC<SuiviChantierProps> = ({
  projet,
  onRetour,
  onAjouterSituation,
  onAjouterTS,
  onAjouterIncident,
  onResoudreIncident,
  onAjouterSituationST,
}) => {
  const projetCalcule = useProjetCalculations(projet);
  const [modalLotId, setModalLotId] = useState<string | null>(null);

  const modalLot = modalLotId
    ? projetCalcule.lotsCalcules.find(l => l.id === modalLotId)
    : null;

  return (
    <div>
      <SuiviChantierHeader projet={projetCalcule} onRetour={onRetour} />

      <MATOverview projet={projetCalcule} />

      <GanttChart
        lots={projetCalcule.lotsCalcules}
        projetDateDebut={projet.dateDebut}
        projetDateFin={projet.dateFin}
      />

      <LotTable
        lots={projetCalcule.lotsCalcules}
        onAjouterSituation={(lotId) => setModalLotId(lotId)}
        onAjouterTS={(lotId, ts) => onAjouterTS(projet.id, lotId, ts)}
        onAjouterSituationST={onAjouterSituationST
          ? (lotId, situation) => onAjouterSituationST(projet.id, lotId, situation)
          : undefined
        }
      />

      <IncidentsSection
        incidentsOuverts={projetCalcule.incidentsOuverts}
        incidentsResolus={projetCalcule.incidentsResolus}
        onAjouterIncident={onAjouterIncident
          ? (incident) => onAjouterIncident(projet.id, incident)
          : undefined}
        onResoudreIncident={onResoudreIncident
          ? (incidentId) => onResoudreIncident(projet.id, incidentId)
          : undefined}
      />

      {/* Modal situation */}
      {modalLot && (
        <SituationModal
          lotNom={modalLot.nom}
          numeroSuivant={modalLot.situations.length + 1}
          onValider={(situation) => {
            onAjouterSituation(projet.id, modalLot.id, situation);
            setModalLotId(null);
          }}
          onFermer={() => setModalLotId(null)}
        />
      )}
    </div>
  );
};

export default SuiviChantier;
